<template>
  <div class="tw-flex tw-items-center tw-justify-center tw-h-screen tw-bg-gray-100 tw-w-full">
    <router-view />
  </div>
  </template>
  
  <script setup lang="ts">
  </script>
  
  <style scoped>
  /* Auth sahifasi uchun stil */
  </style>
  